import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-number-cell',
  templateUrl: './number-cell.component.html',
  styleUrl: './number-cell.component.scss'
})
export class NumberCellComponent {
  @Input() data: Number;

}
